import { ChangeDetectorRef, Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import { ConsoleService } from "src/app/core/services/console.service";
import { confirmDialogConfig } from "./../../../core/services/dialog.service";

@Component({
    selector: "app-confirm-dialog",
    templateUrl: "./confirm-dialog.component.html",
    styleUrls: ["./confirm-dialog.component.scss"],
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {
  config: confirmDialogConfig = {};
  randomNum: number;
  typingText;
  isChecked: boolean = false;
  chipsValue: string[];

  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.config = data;
    ConsoleService.info("config", this.config);
  }

  ngOnInit() {
    if (this.config.confirmByWritingText)
      this.randomNum = Math.floor(1000 + Math.random() * 9000);

    this.config.confirmBtnColor = this.config.confirmBtnColor || "btn-success";
    if (this.config.isConfirmDelete) this.config.confirmBtnColor = "btn-danger";

    if (this.config?.isShowChip)
      this.chipsValue = this.config?.content.split("-");

    ConsoleService.info("this.config?.isShowChip", this.config?.isShowChip);
  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  confirm() {
    if (this.config.isShowCheckBox)
      this.dialogRef.close({ isChecked: this.isChecked });
    else this.dialogRef.close(true);
  }

  onClose() {
    this.dialogRef.close(false);
  }
}
